import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

export function isFormControl(
  ctrl: AbstractControl,
): ctrl is UntypedFormControl {
  return ctrl instanceof UntypedFormControl;
}

/**
 * Type guard for `FormArray`.
 * @param ctrl Control instance to check
 *
 * @returns
 * `true` if `ctrl` extends `FormArray`
 */
export function isFormArray(ctrl: AbstractControl): ctrl is UntypedFormArray {
  return ctrl instanceof UntypedFormArray;
}

/**
 * Type guard for `FormGroup`.
 * @param ctrl Control instance to check
 *
 * @returns
 * `true` of `ctrl` extends `FormGroup`
 */
export function isFormGroup(ctrl: AbstractControl): ctrl is UntypedFormGroup {
  return ctrl instanceof UntypedFormGroup;
}

/**
 * Type guard for either `FormGroup` or `FormArray`.
 * @param ctrl Control instance to check
 *
 * @returns
 * `true` if `ctrl` extends either `FormGroup` or `FormArray`.
 */
export function isAggregatedFormControl(
  ctrl: AbstractControl,
): ctrl is UntypedFormGroup | UntypedFormArray {
  return isFormGroup(ctrl) || isFormArray(ctrl);
}
